import Loader from "react-loader-spinner";
import { faBalanceScaleLeft } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { getBenefitItems } from "../store/api/DocumentsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { Printer } from "react-bootstrap-icons"


const BenefitItems = () => {
    const history = useHistory();
    const filterData = useRef({});
    const [benefitItems, setBenefitItems] = useState({ Data: [] });
    function search() {
        const pDateFrom = document.getElementsByName("DateFrom")[0]?.value;
        if (pDateFrom === "" || !pDateFrom) {
            filterData.current.DateFrom = null;
        }
        const pDateTo = document.getElementsByName("DateTo")[0]?.value;
        if (pDateTo === "" || !pDateTo) {
            filterData.current.DateTo = null;
        }
        getBenefitItems(filterData.current.DateFrom, filterData.current.DateTo, setBenefitItems);
    }
    function printReport(e) {
        const searchArgs = { ...filterData.current };
        history.push({
            pathname: `/PrintViewer/BenefitItems/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetBenefitItems?dateFrom=${filterData.current.DateFrom}&dateTo=${filterData.current.DateTo}`,
                method: "get",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
        search();
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBalanceScaleLeft} size="lg" />
                    &nbsp;
                    گزارش سود و زیان
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <Row className="rowBorder">
                        <Col md={2} className="form-group">
                            <label>از تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateFrom" onChange={value => filterData.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تا تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateTo" onChange={value => filterData.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px", maxWidth: "max-content" }}>
                            <Button className="group-Btn" onClick={search}>سود و زیان</Button>
                        </Col>
                        <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px", maxWidth: "max-content" }}>
                            <Button className="group-Btn" variant="secondary" onClick={printReport}><Printer size={17} />&nbsp;چاپ گزارش </Button>
                        </Col>
                    </Row>
                    {!benefitItems?.Data &&
                        <div className="mt-2" style={{ textAlign: "center", width: "100%" }}>
                            <Loader type="BallTriangle" width={35} height={35} color="#bb1370" />
                        </div>
                    }
                    {benefitItems?.Data &&
                        <Row className="mt-3" style={{ margin: 0, padding: "20px", justifyContent: "space-between" }}>
                            <Col md={5} className="rowBorder">
                                <div className="rowTitle">فروش</div>
                                <table className="mt-3">
                                    <tbody>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>فروش ناخالص: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.SaleAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- تخفیفات فروش:</td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.SaleDiscount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- برگشت از فروش:</td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.ReturnFromSaleAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}><hr /></td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold", color: "green" }}>فروش خالص: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.PureSaleAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <Col md={5} className="rowBorder">
                                <div className="rowTitle">خرید</div>
                                <table className="mt-3">
                                    <tbody>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>خرید طی دوره:</td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.PurchaseAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- تخفیفات خرید:</td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.PurchaseDiscount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- برگشت از خرید:</td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.ReturnFromPurchaseAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}><hr /></td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold", color: "green" }}>خرید خالص: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.PurePurchaseAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <Col md={5} className="rowBorder mt-3">
                                <div className="rowTitle">بهای تمام شده کالای فروش رفته: </div>
                                <table className="mt-3">
                                    <tbody>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>موجودی اول دوره انبار: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.StartDurationInventory ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>+ خرید خالص: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.PurePurchaseAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- موجودی طی دوره(منتهی به تاریخ پایان): </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.EndDurationInventory ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}><hr /></td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold", color: "green" }}>بهای تمام شده کالای فروش رفته:</td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.CostSale ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                            <Col md={5} className="rowBorder mt-3">
                                <div className="rowTitle">محاسبه سود و زیان: </div>
                                <table className="mt-3">
                                    <tbody>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>فروش خالص: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.PureSaleAmount ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- بهای تمام شده کالای فروش رفته: </td>
                                            <td style={{ direction: "ltr" }}>{Number(benefitItems.Data.CostSale ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>- هزینه ها: </td>
                                            <td style={{ direction: "ltr" }}>
                                                {Number(benefitItems.Data.CostAmount ?? 0).toLocaleString("en")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>+ سایر درآمدها: </td>
                                            <td style={{ direction: "ltr" }}>
                                                {Number(benefitItems.Data.IncomesAmount ?? 0).toLocaleString("en")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}><hr /></td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>
                                                <span style={{ color: "green" }}>سـود</span>/
                                                <span style={{ color: "red" }}>زیـان</span>:
                                            </td>
                                            <td style={{ direction: "ltr", color: Number(benefitItems.Data.FinalResult ?? 0) < 0 ? "red" : "green" }}>{Number(benefitItems.Data.FinalResult ?? 0).toLocaleString("en")}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}
export default BenefitItems;